import { TextField, Button, Typography } from "@material-ui/core";

import { Link } from "react-router-dom";
import styled from "styled-components";
import { Alert as AlertMaterialUI } from "@material-ui/lab";

export const Container = styled.section`
  max-width:320px;
  display: flex;
  flex-direction:column;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 300px;
`;

export const Logo = styled.img`
  align-self: center;
  width: 180px;
  margin-bottom: 40px;
`;

export const CustomTypography = styled(Typography)`
    font-size:15px;
    text-align:center;
    color:#fff;
    margin-bottom:15px;
`;

export const Input = styled(TextField)`
  margin-bottom: 15px !important;
  

  input {
    width:300px;
    background: #ffffff;
    height: 1.1876em;
    padding: 27px 12px 10px;
  }
`;

export const CustomButton = styled(Button)`
  color:#676a6c;
  background:#f5f5f5;
  font-size:14px;
`;

export const CustomLink = styled(Link)`
  margin-top: 20px;
  align-self: center;
  color: #ffffff;
  text-decoration: none;
  font-weight: normal;
  font-size:13px;

  :hover {
    text-decoration: underline;
  }
`;
export const Alert = styled(AlertMaterialUI)`
  margin-bottom: 20px;
`;
